// ---------------- Trigger config + helpers ----------------
import { useClient } from "../../../../context/ClientProvider";

const TRIGGER_CATEGORIES = [
  "Communications & Leisure",
  "Personal Costs",
  "Food & Housekeeping",
] as const;

type TriggerCategory = (typeof TRIGGER_CATEGORIES)[number];

type TriggerFigureCfg = {
  name: TriggerCategory;
  firstAdult: number;
  additionalAdult: number;
  children16to18: number;
  childrenUnder16: number;
};

function calcTriggerLimit(
  adults: number,
  childrenUnder16: number,
  children16to18: number,
  cfg?: TriggerFigureCfg,
) {
  if (!cfg) return 0;
  const extraAdults = Math.max(0, (adults ?? 0) - 1);
  return (
    (cfg.firstAdult ?? 0) +
    (cfg.additionalAdult ?? 0) * extraAdults +
    (cfg.children16to18 ?? 0) * (children16to18 ?? 0) +
    (cfg.childrenUnder16 ?? 0) * (childrenUnder16 ?? 0)
  );
}

// ----------------------------------------------------------

function useTriggerFiguresFromService(): TriggerFigureCfg[] {
  const { clientConfig } = useClient().useGetConfig();
  return clientConfig?.layout?.sfs?.triggerFigures ?? [];
}

export { calcTriggerLimit, TRIGGER_CATEGORIES, useTriggerFiguresFromService };

export type { TriggerCategory, TriggerFigureCfg };
